//ANGULAR
import { Router, RouterModule } from '@angular/router';
import { Component, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
//SERVICIOS
import { TranslateService } from '@ngx-translate/core';
import { RecipientsService } from 'src/app/core/services/recipients.service';
import { BalanceService } from 'src/app/core/services/balance.service';
import { NotificationService } from 'src/app/core/services/notification.service';
//OTROS
import { CurrencyValidatorDirective } from 'src/app/shared/directives/currency-validator.directive';
import { CashOutRequest } from 'src/app/core/models/request/cash-out-request';
import { currencyToNumber } from 'src/app/shared/functions/currency.functions';
import { RecipientModel } from 'src/app/core/models/recipient.model';
import { SelectRecipientsComponent } from './select-recipients/select-recipients.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { MatStepper } from '@angular/material/stepper';
import { MatRadioButton } from '@angular/material/radio';
import { StorageService } from 'src/app/core/services/storage.service';
import { IdentityService } from 'src/app/core/services/identity.service';
import {
  allowOnlyLettersAndNumbers,
  allowPasteOnlyLettersAndNumbers,
  allowDropOnlyLettersAndNumbers
} from 'src/app/shared/functions/input-validations.functions';
import { BaseResponseClass } from 'src/app/core/models/response/base-response-class.model';

@Component({
  selector: 'app-cash-out',
  templateUrl: './cash-out.component.html',
  styleUrls: ['./cash-out.component.scss']
})
export class CashOutComponent implements OnInit {
  private readonly MINIMIZED: string = 'minimized';
  private readonly MAXIMIZED: string = 'maximized';

  @ViewChild('formCashOut') formCashOut;
  @ViewChild('currencyInput') currencyInput: ElementRef;
  @ViewChild('inputCash') inputCash: ElementRef;
  @ViewChild(CurrencyValidatorDirective) currencyValidatorDirective: CurrencyValidatorDirective;
  @ViewChild('selectRecipients') selectRecpients;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('checkAlias') checkAlias: MatRadioButton;

  formCashOutTransfer: UntypedFormGroup;
  formDestinatario: UntypedFormGroup;
  formMonto: UntypedFormGroup;
  formConfirmar: UntypedFormGroup;
  cashOutInputCurrency: string = '$0,00';
  monto = 0;
  cashOut: CashOutRequest;
  isConsultaCVU: boolean = true;
  loading: boolean = false;
  montoDown: boolean = true;
  errorIndex = 0;
  isLinear: boolean = false;
  balanceAvailable = '$0,00';
  inputValue = 0;
  transferOK: boolean = false;
  transferErr: boolean = false;
  show: boolean = true;
  error = '';
  showRecipients: boolean = false;
  habilitarGuardado: boolean = false;
  isRecipient: boolean = false;
  showCBU: boolean = false;
  campoAlias: string = '';
  campoCBU: string = '';
  formaTransferecia: string;
  existeRecipient: boolean;
  seGuardaCBU: boolean;
  paymentInProgress: boolean = false;
  balances;
  dialogConfirm: MatDialogRef<ConfirmarDialogComponent>;
  cuitMatches: boolean = false;
  recipients: RecipientModel[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private translateService: TranslateService,
    private balanceService: BalanceService,
    private notificationService: NotificationService,
    private recipientsService: RecipientsService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
    private storageService: StorageService,
    private identityServices: IdentityService
  ) {}

  ngOnInit() {
    this.recipientsService.getRecipients().then((recipients) => {
      this.recipients = recipients;
    });
    this.habilitarGuardado = false;
    this.cashOut = new CashOutRequest();
    this.cashOut.uuid = this.identityServices.getUUID();
    this.formCashOutTransfer = this.formBuilder.group({});
    this.formDestinatario = this.formBuilder.group({
      inputCBU: new UntypedFormControl(this.cashOut.cbu, Validators.required),
      nombreDestinatario: new UntypedFormControl('')
    });
    this.formMonto = this.formBuilder.group({
      comercioMonto: new UntypedFormControl(null, Validators.required)
    });
    this.formConfirmar = this.formBuilder.group({
      comercioCuit: new UntypedFormControl(''),
      checker: new UntypedFormControl(''),
      cuitChecker: new UntypedFormControl('')
    });
    this.formMonto.valueChanges.subscribe((current) => {
      let amountNumeric = currencyToNumber(current.comercioMonto);
      if (amountNumeric > 0) {
        this.montoDown = true;
        this.formControls[1].comercioMonto.setErrors({});
        this.formControls[1].comercioMonto.updateValueAndValidity({ onlySelf: false, emitEvent: false });
      } else {
        this.montoDown = false;
        this.errorIndex = 2;
        this.formControls[1].comercioMonto.setErrors({ incorrect: true });
      }
    });
  }

  resetControls(control: string) {
    this.formDestinatario.controls[control].reset();
  }

  async mostrarDestinatarios() {
    this.resetControls('nombreDestinatario');
    this.resetControls('inputCBU');
    this.showRecipients = !this.showRecipients;
    await this.recipientsService.getRecipients();
  }

  deleteRecipients(recipient: any) {
    this.resetControls('nombreDestinatario');
    this.resetControls('inputCBU');
    this.recipientsService.deleteRecipient(recipient);
  }

  resetFormCashOut() {
    this.isConsultaCVU = true;
    this.cashOutInputCurrency = '$0,00';
    this.monto = 0;
    this.cashOut.monto = 0;
    this.resetCampoAliasCBU();
  }

  nextStep(user: string) {
    this.cashOutInputCurrency = this.currencyValidatorDirective.output;
  }

  checkRecipient(name: string) {
    if (this.recipients) {
      let is = this.recipients.filter((user) => user.nombre && user.nombre.toUpperCase().includes(name.toUpperCase()));
      this.isRecipient = is.length != 0 ? true : false;
      this.habilitarGuardado = is.length != 0 ? true : false;
    }
  }

  async transferir(form) {
    this.showCBU = true;
    this.showRecipients = false;
    if (this.formDestinatario.valid && this.formMonto.valid) {
      this.loading = true;
      if (this.habilitarGuardado && !this.isRecipient) {
        await this.saveRecipient();
      }
      this.dialogConfirm = this.dialog.open(ConfirmarDialogComponent, {
        data: {
          info: 'Atención',
          title: 'Estas por realizar una transferencia. ¿Quiere confirmarla?',
          button: 'Confirmar'
        }
      });
      this.dialogConfirm.afterClosed().subscribe(async (result) => {
        if (result) {
          this.balanceService
            .cashOut(this.cashOut)
            .then(async (response) => {
              this.transferOK = true;
              this.balanceService.getBalance();
              this.notificationService.mgsView({
                error: null,
                messenger: response.message,
                title: this.translate('dialog_cash.labels.cashout_title'),
                type: 1,
                configNotification: null
              });
              this.loading = false;
              this.habilitarGuardado = false;
              this.show = false;
              this.paymentInProgress = false;
              this.stepper.reset();
              this.resetCampoAliasCBU();
              localStorage.setItem('balances', JSON.stringify(await this.balanceService.getVirtualAccountBalance()));
              sessionStorage.removeItem(this.MINIMIZED);
              sessionStorage.removeItem(this.MAXIMIZED);
            })
            .catch((error: Error) => {
              this.transferErr = true;
              this.show = false;
              this.error = error.message.toString();
              this.notificationService.mgsView({
                error: 404,
                messenger: error.message,
                title: 'Transferencia',
                type: 3,
                configNotification: null
              });
              this.loading = false;
              this.paymentInProgress = false;
              this.stepper.reset();
              this.resetCampoAliasCBU();
            });
        } else {
          this.loading = false;
        }
      });
    }
  }

  cancelTx() {
    this.formaATransferir('alias');
    this.checkAlias.checked = true;
    this.cashOutInputCurrency = '$0,00';
    this.transferErr = false;
    this.transferOK = false;
    this.loading = false;
    this.paymentInProgress = false;
    this.showRecipients = false;
    this.stepper.reset();
    this.resetCampoAliasCBU();
  }

  async saveRecipient() {
    let response;
    this.seGuardaCBU
      ? (response = await this.recipientsService.saveRecipient(
          new RecipientModel(0, 'F', this.cashOut.titular, this.formDestinatario.value.inputCBU.toUpperCase())
        ))
      : (response = await this.recipientsService.saveRecipient(
          new RecipientModel(0, 'F', this.cashOut.titular, null, this.formDestinatario.value.inputCBU.toUpperCase())
        ));
  }

  retry() {
    this.transferOK = false;
    this.transferErr = false;
    this.show = true;
    this.error = '';
    this.resetFormCashOut();
  }

  get formControls() {
    return [this.formConfirmar.controls, this.formMonto.controls, this.formDestinatario.controls];
  }

  validarMonto(retirar) {
    if (this.monto < retirar) {
      this.montoDown = false;
      this.errorIndex = 1;
      this.formControls[1].comercioMonto.setErrors({ incorrect: true });
    } else if (retirar == 0 || retirar == '') {
      this.monto = 0;
      this.montoDown = false;
      this.errorIndex = 2;
      this.formControls[1].comercioMonto.setErrors({ incorrect: true });
    } else {
      this.montoDown = true;
      this.formControls[1].comercioMonto.setErrors({});
      this.formControls[1].comercioMonto.updateValueAndValidity();
    }
  }

  formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP'
  });

  deleteSpaces(str) {
    if (typeof str == 'string' && str.length > 0) {
      let notSpace: any = str.split(' ');
      notSpace = notSpace.join('');
      return notSpace;
    } else {
      return str;
    }
  }

  async verificarCVU() {
    if (this.showRecipients) this.selectRecpients.selectedRecipient = undefined;
    this.loading = true;
    const accountInfo = await this.balanceService.getBalance();
    this.balanceAvailable = this.formatter.format(accountInfo.accountBalance);
    if (this.formDestinatario.valid) {
      let amountNumeric = currencyToNumber(this.cashOutInputCurrency);
      this.cashOut.monto = amountNumeric;
      this.validarMonto(+amountNumeric);
      this.seleccionarAliasCBU();
      this.balanceService
        .getHolder(this.deleteSpaces(this.cashOut.cbu.toUpperCase()))
        .then((response) => {
          console.log(response);

          if (response.resultCode === -2) {
            this.notificationService.mgsView({
              error: 404,
              messenger: response.message,
              title: 'Transferencia',
              type: 4,
              configNotification: null
            });
            this.isConsultaCVU = true;
            this.loading = false;
          } else {
            this.cashOut.titular = response.object.nombre;
            this.cashOut.cuit = response.object.cuit;
            this.setMatchingCuit();
            this.isConsultaCVU = false;
            this.loading = false;
          }
        })
        .catch((error: string) => {
          this.notificationService.mgsView({
            error: 404,
            messenger: error,
            title: 'Transferencia',
            type: 4,
            configNotification: null
          });
          this.isConsultaCVU = true;
          this.loading = false;
        });
    } else {
      this.notificationService.mgsView({
        error: 404,
        messenger: 'CBU/CVU o Alias inválido',
        title: 'Transferencia',
        type: 3,
        configNotification: null
      });
      this.isConsultaCVU = true;
      this.loading = false;
    }
  }

  setMatchingCuit() {
    const loggedOrganismCuit = this.storageService.getAsObject('user')?.organismo?.numeroDocumento;
    this.cuitMatches = loggedOrganismCuit == this.cashOut.cuit;
  }

  setAliasCBU(recipient) {
    if (recipient.cvuCbu != null) {
      this.campoCBU = recipient.cvuCbu;
      this.seGuardaCBU = true;
    } else {
      this.campoCBU = recipient.alias;
      this.seGuardaCBU = false;
    }
    this.formDestinatario.controls['inputCBU'].setValue(this.deleteSpaces(this.campoCBU.toUpperCase()));
  }

  seleccionarAliasCBU() {
    this.cashOut.cbu = this.deleteSpaces(this.campoCBU.toUpperCase());
  }

  async consultaCVU() {
    if (this.formDestinatario.valid && this.formMonto.valid) {
      this.loading = true;
      this.cashOut.cbu = this.formDestinatario.value.inputCBU;
      this.cashOut.cbu.trim();
      this.cashOutInputCurrency = this.currencyValidatorDirective.output;
      let amountNumeric = currencyToNumber(this.cashOutInputCurrency);
      this.cashOut.cuit = this.formConfirmar.value.comercioCuit;
      this.cashOut.monto = amountNumeric;
      const accountInfo = await this.balanceService.getBalance();
      this.monto = accountInfo.accountBalance;
      if (+amountNumeric >= this.cashOut.monto && +amountNumeric > 0) {
        this.balanceService
          .getHolder(this.cashOut.cbu)
          .then((response: { object: { cuit: string; nombre: string } }) => {
            this.cashOut.cuit = response.object.cuit;
            this.cashOut.titular = response.object.nombre;
            this.isConsultaCVU = false;
            this.loading = false;
          })
          .catch((error: string) => {
            this.notificationService.mgsView({
              error: 404,
              messenger: error,
              title: 'Transferencia',
              type: 4,
              configNotification: null
            });
            this.isConsultaCVU = true;
            this.loading = false;
          });
      } else {
        this.validarMonto(+amountNumeric);
        this.loading = false;
      }
    }
  }

  maskCuit(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(2, 10);
    let end = cuit.substring(10, 11);
    return `${first}-${dni}-${end}`;
  }

  volverConsulta() {
    this.isConsultaCVU = true;
  }

  currencyInputChanged(value) {
    if (value == '' && this.inputCash) {
      this.inputCash.nativeElement.value = 0;
      this.monto = 0;
    }
    if (value) {
      if (value.toString().indexOf(',') >= 0) value = value.replace(',', '.');
      if (value.toString().indexOf(/[$,]/g) >= 0) value = value.replace(/[$,]/g, '');
      var num = value;
      this.monto = Number(num);
    } else {
      this.monto = 0;
    }
  }

  getErrorMessage(valueError: number) {
    switch (valueError) {
      case 1:
        return this.translate('dialog_cash.labels.validations.amount_major_than_available');
      case 2:
        return this.translate('dialog_cash.labels.validations.amount_zero');
      case 6:
        return this.translate('dialog_cash.labels.validations.amount_required');
      default:
        return '';
    }
  }

  translate(key: string, paramKey?: string): string {
    let param;
    if (paramKey) {
      param = { campo: this.translateService.instant(paramKey) };
    }
    return this.translateService.instant(key, param);
  }

  showMovements() {
    this.router.navigate(['/user/movements/'], { queryParams: { page: '1' } });
  }

  goBack() {
    this.router.navigate(['user/account-yacare']);
  }

  formaATransferir(event) {
    if (event.value == 'alias') {
      this.showCBU = false;
      this.showRecipients = false;
      this.formaTransferecia = 'alias';
    } else {
      this.showCBU = false;
      this.showRecipients = true;
    }
    this.resetCampoAliasCBU();
  }

  resetCampoAliasCBU() {
    this.campoCBU = '';
  }

  camposValidos() {
    // Se valida los campos dependiendo si se muetra la agenda o no.
    return !this.showRecipients
      ? this.showCBU
        ? this.campoCBU?.length == 22
        : this.campoCBU?.length > 5 && this.campoCBU?.length <= 22
      : this.campoCBU?.length > 5;
  }

  cambiarHabilitarGuardado(habilitarGuardado) {
    habilitarGuardado ? (this.habilitarGuardado = false) : (this.habilitarGuardado = true);
  }

  public checkPattern(event: KeyboardEvent) {
    allowOnlyLettersAndNumbers(event);
  }

  public checkPaste(event: ClipboardEvent) {
    allowPasteOnlyLettersAndNumbers(event);
  }

  public checkDrop(event: DragEvent) {
    allowDropOnlyLettersAndNumbers(event);
  }
}
